import plate1 from './assets/plate-1.png'
import plate2 from './assets/plate-2.png'
import plate3 from './assets/plate-3.png'
import plate4 from './assets/plate-4.png'
import plate5 from './assets/plate-5.png'
import plate6 from './assets/plate-6.png'
import plate7 from './assets/plate-7.png'
import plate8 from './assets/plate-8.png'
import plate9 from './assets/plate-9.png'
import plate10 from './assets/plate-10.png'
import plate11 from './assets/plate-11.png'
import plate12 from './assets/plate-12.png'

export type BenefitSegment = { text: string; bold?: boolean }
export type Benefit = { heading: string; body: BenefitSegment[] }

// Plate cut-out order per breakpoint, matching the Figma frames:
//   mobile  → node 8192-10698 (3 plates)
//   tablet  → node 8192-10791 (5 plates)
//   desktop → node 8192-10593 (12 plates, 3×4 grid, row-major)
export const MOBILE_PLATES = [plate1, plate8, plate4]

export const TABLET_PLATES = [plate5, plate8, plate1, plate4, plate12]

export const DESKTOP_PLATES = [
  plate1,
  plate5,
  plate9,
  plate2,
  plate6,
  plate10,
  plate3,
  plate8,
  plate11,
  plate4,
  plate7,
  plate12,
]

export const BENEFITS: Benefit[] = [
  {
    heading: 'Super tasty, super fast',
    body: [{ text: 'We’ve doubled our' }, { text: ' 10-Min Meals.', bold: true }],
  },
  {
    heading: 'NEW Heat & Eat range',
    body: [
      { text: 'All the flavour of Gousto, ' },
      { text: 'none of the prep', bold: true },
      { text: '. ' },
    ],
  },
  {
    heading: "UK's best value recipe box",
    body: [
      { text: 'With ' },
      { text: '100% British', bold: true },
      { text: ' meat and ' },
      { text: 'fresh seasonal produce', bold: true },
      { text: ', you can enjoy great-tasting dinners, for\u00A0less.' },
    ],
  },
]

export const CTA_TEXT = "See this week's menu"
